export default __webpack_public_path__ + "static/media/patient_consent_form.b43d8ffc.pdf";